/* eslint-disable  */
import { Injectable } from '@angular/core';
import { ApiServiceOld } from './api-old.service';
import { CONSTANTS } from './config.service';
import { LoggerService } from './logger.service';
import { PrefsService } from './prefs.service';
import { PubSubService } from './pub-sub.service';
import { SqlHelperService } from './sql-helper.service';
import { UtilsService } from './utils.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class PosterService {
  db;
  table = CONSTANTS.postsTableName;
  appVersion;
  serverActivationCode;
  authCode;
  surveyFinishedUnsubscriber;
  tripEndedUnsubscriber;
  initialized = false;
  sending = false;
  createTableSql =
    'CREATE TABLE IF NOT EXISTS ' + this.table + '(' + 'id INTEGER PRIMARY KEY AUTOINCREMENT, ' + 'json TEXT, ' + 'url TEXT' + ');';

  constructor(
    private logger: LoggerService,
    private utils: UtilsService,
    private prefs: PrefsService,
    private pubSub: PubSubService,
    private sqlHelper: SqlHelperService,
    private api: ApiServiceOld
  ) {
    this.logger.log('Poster constructor - subcribing to tripEnded and surveyFinished events', MSRemoteLoggerCategory.POSTER_SERVICE);
    this.pubSub.subscribe(CONSTANTS.EVENTS.tripEnded, (...args) => {
      this.sendAll();
    });
    this.pubSub.subscribe(CONSTANTS.EVENTS.surveyFinished, (...args) => {
      this.sendAll();
    });
  }

  upload(path, content, httpConfig) {
    let config = {};
    let data = {};
    // we may make posts prior to activation. Help the server out by explicitly sending 'omitted'
    const activationCode = this.serverActivationCode ? this.serverActivationCode : 'omitted';

    if (httpConfig) {
      config = Object.assign({}, httpConfig);
    }

    data = Object.assign(content ? content : {}, { activationCode, appVersion: this.appVersion, authCode: this.authCode });

    return new Promise((resolve, reject) => {
      this.api.post(path, data).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          // HACK
          // angular assumes response is json, but it's just text
          if (err.status === 200) {
            resolve('Success posting');
          } else {
            reject(err);
          }
        }
      );
    });
  }

  uploadRow(postRow) {
    return this.upload(postRow.url, JSON.parse(postRow.json), null);
  }

  sendAll() {
    if (this.sending) {
      this.logger.log('Poster already sending', MSRemoteLoggerCategory.POSTER_SERVICE);
      return Promise.resolve(null);
    }

    if (!this.initialized) {
      this.logger.warn('Attempted poster send before initialized', MSRemoteLoggerCategory.POSTER_SERVICE);
      return Promise.resolve(null);
    }

    this.sending = true;

    return this.sqlHelper
      .getSelectPromise(this.db, 'posts', ['id', 'json', 'url'])
      .then((posts: any[]) => {
        const promises = [];

        posts.forEach((post) => {
          promises.push(
            this.uploadRow(post).then((res) => this.sqlHelper.getDeletePromise(this.db, this.table, { id: post.id }))
            // .catch(err => {
            //     // TODO
            //     // (logger.makeFailureLogger('Issue fetching/sending posts'))(arguments);
            //     this.logger.error("Error sending post to server ")
            //     return Promise.resolve();
            // })
          );
        });

        return Promise.all(promises);
      })
      .catch((err) => {
        // TODO
        // (logger.makeFailureLogger('Issue fetching/sending posts'))(arguments);

        this.logger.error('Error sending post to server ', MSRemoteLoggerCategory.POSTER_SERVICE, err);
      })
      .then(() => {
        this.sending = false;
      });
  }

  add(url, content, preJsond?: boolean) {
    if (this.initialized) {
      this.logger.log('Adding post', MSRemoteLoggerCategory.POSTER_SERVICE);
      const json = preJsond ? content : this.utils.toJson(content);
      return this.sqlHelper.getInsertPromise(this.db, this.table, { json, url });
    } else {
      // pre-init?
      this.logger.error("Poster not init'd, dropping", MSRemoteLoggerCategory.POSTER_SERVICE, url, content);
      return Promise.reject('Pre-init');
    }
  }

  send() {
    return this.sendAll();
  }

  addThenSend(url, content, preJsond?: boolean) {
    return this.add(url, content, preJsond).then(() => this.send());
  }

  initialize() {
    return this.prefs
      .getPromises('activationCode', 'appVersion', 'authCode')
      .then((results) => {
        this.serverActivationCode = results[0];
        this.appVersion = results[1];
        this.authCode = results[2];
        return this.sqlHelper.createDb({
          name: CONSTANTS.mainFrontEndDbName,
          location: 'default',
          androidDatabaseProvider: 'system',
          androidLockWorkaround: 1
        });
      })
      .then((db) => {
        this.db = db;
        return this.sqlHelper.createTablePromise(this.db, this.createTableSql);
      })
      .then(() => {
        this.logger.debug('POSTER INIT SUCCESS', MSRemoteLoggerCategory.POSTER_SERVICE);
        this.initialized = true;
        return Promise.resolve();
      })
      .catch((err) => {
        this.logger.error('POSTER INIT FAILURE', MSRemoteLoggerCategory.POSTER_SERVICE);
        this.logger.error(err, MSRemoteLoggerCategory.POSTER_SERVICE);
        throw err;
      });
  }

  // end: function () {
  //     pubSub.unsubscribe(surveyFinishedUnsubscriber);
  //     pubSub.unsubscribe(tripEndedUnsubscriber);
  //     return sqlHelper.getRawSqlPromise(db, 'DROP TABLE IF EXISTS posts');
  // }
}
